<template>
  <div class="page-content">

    <page-template
      ref="deposit"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </page-template>
  </div>
</template>

<script>
  import api from "@/config/api";
  import pageTemplate from "@/components/template/pageTemplate";

  export default {
    components: {pageTemplate},
    data() {
      return {
        indexShow: false,
        toolConfig: [
          {
            label: "导出",
            code: "export",
            callback: this.exportData
          },
        ],
        searchOptions: {
          simple: [
            {
              label: '会员姓名/手机号/卡号',
              prop: 'memberName',
              type: 'input',
              span: 24,
              placeholder: "请输入会员姓名/手机号/卡号",
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "会员类别",
              prop: "memberCategoryId",
              type: "select",
              span: 8,
              data: [],
              url: api.member.category,
            },
            {
              label: "发卡门店",
              prop: "cardStoreId",
              type: "select",
              span: 8,
              data: [],
              url: api.store.store,
              isHasAll: true,//下拉选择添加‘总部’字段
            },
            {
              label: "消费门店",
              prop: "consumeStoreId",
              type: "select",
              span: 8,
              data: [],
              url: api.store.store,
              isHasAll: true,//下拉选择添加‘总部’字段
            },
            {
              label: "业务类型",
              prop: "businessType",
              type: "select",
              span: 8,
              data: this.$utils.getCacheStatus('mbMemberIntegralRecord.businessType')
            },
          ],
        },
        tableOptions: {
          showSummary: true,
          summaryColumns: ['consumeAmount', 'consumeIntegral', 'giveIntegral'],
          indexShow: true, //是否显示索引
          columns: [
            {
              label: "消费分店",
              prop: "consumeStoreName",
              align: "center",
              width: "120"
            },
            {
              label: "姓名",
              prop: "memberName",
              align: "center",
              width: "90"
            },
            {
              label: "流水单号",
              prop: "orderNo",
              align: "center",
              width: "210"
            },
            {
              label: "消费时间",
              prop: "lastModifyDttm",
              align: "center",
              width: "150"
            },
            {
              label: "业务类型",
              prop: "businessType",
              align: "center",
              width: "110",
              enumData: this.$utils.getCacheStatus('mbMemberIntegralRecord.businessType')
            },
            {
              label: "操作说明",
              prop: "operationType",
              align: "center",
              width: "110",
              enumData: this.$utils.getCacheStatus('mbMemberIntegralRecord.operationType')
            },
            {
              label: "消费金额",
              prop: "consumeAmount",
              align: "center",
              width: "90"
            },
            {
              label: "积分减少",
              prop: "consumeIntegral",
              align: "center",
              width: "90"
            },
            {
              label: '积分增加',
              prop: "giveIntegral",
              align: "center",
              width: "90"
            },
            {
              label: '会员类别',
              prop: "categoryName",
              align: "center",
              width: "120"
            },
            {
              label: '手机号',
              prop: "phone",
              align: "center",
              width: "120"
            },
            {
              label: '入会门店',
              prop: "cardStoreName",
              align: "center",
              width: "120"
            },
            {
              label: '入会时间',
              prop: "memberCreateDttm",
              align: "center",
              width: "150"
            },
            {
              label: "备注",
              prop: "remarks",
              align: "center",
              width: "90"
            },
          ],
          url: api.member.integralRecord
        },
      };
    },
    created() {
    },
    mounted() {
    },
    methods: {
      exportData() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["deposit"].getCurrentParams();
        this.$axios.PostBlob(api.member.integralRecordExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '积分流水_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    },
  };
</script>




// WEBPACK FOOTER //
// src/page/member/integral/record.vue